import {
    type CaregiverMatchSignal,
    type CaregiverOutreachSignal,
} from '@apps/web/components/outreaches/caregiver_outreach_stats_badges';
import { type CaregiverResponseType } from '@libraries/typescript/api_client';

type MatchSignalsRow = {
    readonly matchSignalsByShift?: Array<CaregiverMatchSignal>;
};

export const getAvailabilitySortPriority = (
    response: CaregiverResponseType | null,
): number => {
    if (response === 'available_interested') {
        return 0;
    }
    if (response === 'unavailable') {
        return 2;
    }
    return 1;
};

export const getMatchSignalForSort = (
    row: MatchSignalsRow,
    selectedShiftId?: string | null,
): CaregiverOutreachSignal => {
    const signals = row.matchSignalsByShift;
    if (signals && signals.length > 0) {
        const selectedSignal =
            (selectedShiftId
                ? signals.find((signal) => signal.shiftId === selectedShiftId)
                : null) ?? signals[0];
        if (selectedSignal) {
            return {
                sameDayShiftCount: selectedSignal.sameDayShiftCount,
                declineCount: selectedSignal.declineCount,
                weeklyHours: selectedSignal.weeklyHours,
                previousVisits: selectedSignal.previousVisits,
                shiftHours: selectedSignal.shiftHours ?? null,
            };
        }
    }

    return {
        sameDayShiftCount: null,
        declineCount: null,
        weeklyHours: null,
        previousVisits: null,
        shiftHours: null,
    };
};

export const compareMetricLowerIsBetter = (
    a: number | null,
    b: number | null,
): number => {
    if (a === null && b === null) {
        return 0;
    }
    if (a === null) {
        return 1;
    }
    if (b === null) {
        return -1;
    }
    return a - b;
};
